module.exports = __webpack_public_path__ + "img/print.80f11f27.svg";